import { render, staticRenderFns } from "./AppointmentSlots.vue?vue&type=template&id=616b9f47&scoped=true"
import script from "./AppointmentSlots.vue?vue&type=script&lang=js"
export * from "./AppointmentSlots.vue?vue&type=script&lang=js"
import style0 from "./AppointmentSlots.vue?vue&type=style&index=0&id=616b9f47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b9f47",
  null
  
)

export default component.exports